import type {
  AutoCompleteFieldProps,
  AutoCompleteOptionType,
} from '@/components';
import { useState } from 'react';
import type { FieldValues } from 'react-hook-form';
import type { z } from 'zod';
import type {
  CorporatesModelType,
  GovernmentSearchSettingFormValues,
  SearchTypeEnum,
} from '../_models/government-search';
import { PAYMENT_SEARCH_SETTING_DEFAULT_VALUES } from '../_utils/search-government';
import { SearchSettingModal } from './SearchSettingModal';
import { SearchWordField } from './SearchWordField';

export type GovernmentSearchFieldProps<
  T extends FieldValues,
  U extends AutoCompleteOptionType,
> = Omit<
  AutoCompleteFieldProps<T, U>,
  'onSearch' | 'options' | 'onSelect' | 'shouldCoexistOnChange' | 'hint'
> & {
  onSelect: (value: {
    corporateInfo: CorporatesModelType | undefined;
  }) => void;
  defaultSearchValue: string | undefined;
  isResetProcessing?: boolean;
  onChangeSearchType?: (searchType: z.infer<typeof SearchTypeEnum>) => void;
  companyNameHint?: string;
  companyNumberHint?: string;
};

export const GovernmentSearchField = <
  T extends FieldValues,
  U extends AutoCompleteOptionType,
>(
  props: GovernmentSearchFieldProps<T, U>,
) => {
  const [openModal, setOpenModal] = useState(false);
  const [searchSetting, setSearchSetting] =
    useState<GovernmentSearchSettingFormValues>(
      PAYMENT_SEARCH_SETTING_DEFAULT_VALUES,
    );

  return (
    <>
      <SearchWordField
        {...props}
        searchSetting={searchSetting}
        onOpenModal={() => setOpenModal(true)}
      />
      <SearchSettingModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onSearchSettingChange={setSearchSetting}
        isResetProcessing={!!props.isResetProcessing}
      />
    </>
  );
};
